import * as React from 'react';
import SilverIcon from './TierIcons/Silver';

const TierIcon = props => {
  const { countryCode } = props;
  const SilverTierIcon = SilverIcon[countryCode.toLowerCase()] || SilverIcon['us'];
  return (
    <React.Fragment>
      <SilverTierIcon {...props} />
    </React.Fragment>
  );
};

export default TierIcon;
